export const SKILL_CATEGORIES = {
    all: "skillsPage.filters.all",
    triggers: "skillsPage.filters.triggers",
    ai: "skillsPage.filters.ai",
    documents: "skillsPage.filters.documents",
    data: "skillsPage.filters.data",
    communication: "skillsPage.filters.communication",
    codeGeneration: "skillsPage.filters.codeGeneration",
    components: "skillsPage.filters.components",
    patterns: "skillsPage.filters.patterns",
    new: "skillsPage.filters.new",
};

export const SKILLS_AVAILABLE = [
    {
        id: "Receive Email",
        name: "Receive Email",
        description:
            "Monitor and read incoming emails from your connected email accounts.",
        descriptionKey: "skillsPage.skills.receiveEmail",
        icon: "📨",
        isTrigger: true,
        serviceRequirement: "awsSES",
        category: "triggers",
    },
    {
        id: "WhatsApp",
        name: "Receive WhatsApp",
        description:
            "Send and receive WhatsApp messages directly from the chat.",
        descriptionKey: "skillsPage.skills.receiveWhatsApp",
        icon: "💬",
        isTrigger: true,
        serviceRequirement: "whatsappApi",
        category: "triggers",
    },
    {
        id: "Webhook",
        name: "Webhook",
        description: "Receive data from a webhook and process it.",
        descriptionKey: "skillsPage.skills.webhook",
        icon: "🌐",
        isTrigger: true,
        serviceRequirement: "none",
        category: "triggers",
    },
    {
        id: "Schedule",
        name: "Schedule",
        description: "Schedule a workflow to run at a specific time.",
        descriptionKey: "skillsPage.skills.schedule",
        icon: "⏰",
        isTrigger: true,
        serviceRequirement: "none",
        category: "triggers",
    },
    {
        id: "Chat GPT",
        name: "Chat GPT",
        description:
            "Powerful AI language model for natural conversations and text generation.",
        descriptionKey: "skillsPage.skills.chatGPT",
        icon: "🤖",
        docsLink: "/docs/skills/chatgpt-skill",
        serviceRequirement: "openai",
        alternativeServices: ["anthropic", "gemini", "groq", "claude"],
        category: "ai",
    },
    {
        id: "Image Generation",
        name: "AI Image Generation",
        description:
            "Generate high-quality images from text descriptions using AI models.",
        descriptionKey: "skillsPage.skills.imageGeneration",
        icon: "🎨",
        serviceRequirement: "openai",
        alternativeServices: ["gemini"],
        category: "ai",
    },
    {
        id: "Image Analysis",
        name: "Image Analysis",
        description:
            "Extract information and analyze content from images using AI.",
        descriptionKey: "skillsPage.skills.imageAnalysis",
        icon: "🖼️",
        serviceRequirement: "openai",
        alternativeServices: ["anthropic", "gemini", "groq", "claude"],
        category: "ai",
    },
    {
        id: "Database Operations",
        name: "Database",
        description: "Your personal information storage.",
        descriptionKey: "skillsPage.skills.database",
        icon: "🗄️",
        docsLink: "/docs/skills/databases",
        serviceRequirement: "none",
        category: "data",
    },
    {
        id: "Send Email",
        name: "Send Email",
        description: "Compose and send emails directly from the chat.",
        descriptionKey: "skillsPage.skills.sendEmail",
        icon: "📧",
        serviceRequirement: "awsSES",
        alternativeServices: ["smtp"],
        category: "communication",
    },
    {
        id: "Send WhatsApp",
        name: "Send WhatsApp",
        description:
            "Send and receive WhatsApp messages directly from the chat.",
        descriptionKey: "skillsPage.skills.sendWhatsApp",
        icon: "💬",
        serviceRequirement: "whatsappApi",
        category: "communication",
    },
    {
        id: "Web Request",
        name: "Web Request",
        description: "Fetch information from any website or online service.",
        descriptionKey: "skillsPage.skills.webRequest",
        icon: "🌐",
        serviceRequirement: "none",
        category: "data",
    },
    {
        id: "Web Search",
        name: "Web Search",
        description:
            "Search the web for real-time information and news articles.",
        descriptionKey: "skillsPage.skills.webSearch",
        icon: "🔍",
        serviceRequirement: "perplexityApi",
        category: "ai",
    },
    {
        id: "Excel Reader",
        name: "Excel Reader",
        description: "Extract and process data from Excel spreadsheets.",
        descriptionKey: "skillsPage.skills.excelReader",
        icon: "📊",
        serviceRequirement: "none",
        category: "documents",
    },
    {
        id: "Excel Generator",
        name: "Excel Generator",
        description: "Generate Excel files with custom data and formatting.",
        descriptionKey: "skillsPage.skills.excelGenerator",
        icon: "📈",
        serviceRequirement: "none",
        category: "documents",
    },
    {
        id: "Excel Template Generator",
        name: "Excel Template Generator",
        description: "Generate new Excel files using existing templates.",
        descriptionKey: "skillsPage.skills.excelTemplateGenerator",
        icon: "📋",
        serviceRequirement: "none",
        category: "documents",
    },
    {
        id: "PDF To Text",
        name: "PDF To Text",
        description: "Extract and process text from PDF documents.",
        descriptionKey: "skillsPage.skills.pdfToText",
        icon: "📄",
        serviceRequirement: "awsTextract",
        category: "documents",
    },
    {
        id: "PDF To Tables",
        name: "PDF To Tables",
        description: "Extract and process tables from PDF documents.",
        descriptionKey: "skillsPage.skills.pdfToTables",
        icon: "📑",
        serviceRequirement: "awsTextract",
        category: "documents",
    },
    {
        id: "OCR",
        name: "OCR",
        description: "Extract text, tables from images using OCR technology.",
        descriptionKey: "skillsPage.skills.ocr",
        icon: "🔍",
        serviceRequirement: "awsTextract",
        category: "documents",
    },
    {
        id: "PDF Document Analysis",
        name: "PDF Document Analysis",
        description: "Analyze PDF documents to extract structured information.",
        descriptionKey: "skillsPage.skills.pdfDocumentAnalysis",
        icon: "🔍",
        serviceRequirement: "awsTextract",
        category: "documents",
    },
    {
        id: "Generate Word Document",
        name: "Generate Word Document",
        description: "Create word documents with custom content.",
        descriptionKey: "skillsPage.skills.generateWordDocument",
        icon: "📄",
        serviceRequirement: "none",
        category: "documents",
    },
    {
        id: "Export to Presentation",
        name: "Export to Presentation",
        description:
            "Export dashboards and charts to PowerPoint or Google Slides.",
        descriptionKey: "skillsPage.skills.exportToPresentation",
        icon: "📽️",
        serviceRequirement: "none",
        category: "documents",
    },
    {
        id: "AI Form Editor",
        name: "AI Form Editor",
        description:
            "Edit forms using natural language prompts and AI assistance.",
        descriptionKey: "skillsPage.skills.aiFormEditor",
        icon: "📋",
        serviceRequirement: "openai",
        alternativeServices: ["anthropic", "gemini", "groq", "claude"],
        category: "ai",
    },
    {
        id: "Dropbox",
        name: "Dropbox",
        description: "Access and manage files in your Dropbox account.",
        descriptionKey: "skillsPage.skills.dropbox",
        icon: "📦",
        serviceRequirement: "dropbox",
        category: "data",
    },
    {
        id: "Google Drive",
        name: "Google Drive",
        description: "Create, access, and manage files in Google Drive.",
        descriptionKey: "skillsPage.skills.googleDrive",
        icon: "📁",
        serviceRequirement: "googleDrive",
        category: "data",
    },
    {
        id: "Audio Transcription",
        name: "Audio Transcription",
        description: "Transcribe audio files to text using OpenAI Whisper.",
        descriptionKey: "skillsPage.skills.audioTranscription",
        icon: "🎤",
        serviceRequirement: "openai",
        category: "ai",
    },
    // Code Generation Skills (for APP_V2)
    {
        id: "offline-pwa",
        name: "Offline Mode & PWA",
        description:
            "Build offline-capable installable web apps (PWA) with service workers.",
        descriptionKey: "skillsPage.skills.offlinePwa",
        icon: "📱",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "radix-ui",
        name: "Radix UI Primitives",
        description:
            "Accessible UI primitives: dialogs, menus, selects, tabs, tooltips, and more.",
        descriptionKey: "skillsPage.skills.radixUi",
        icon: "🧩",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "recharts",
        name: "Recharts",
        description:
            "Create interactive charts: line, bar, pie, area, radar, and scatter.",
        descriptionKey: "skillsPage.skills.recharts",
        icon: "📊",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "react-leaflet",
        name: "React Leaflet Maps",
        description:
            "Build interactive maps with markers, popups, layers, and geolocation.",
        descriptionKey: "skillsPage.skills.reactLeaflet",
        icon: "🗺️",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "fabricjs",
        name: "Fabric.js Canvas Editor",
        description:
            "Build canvas editors for image manipulation and text editing.",
        descriptionKey: "skillsPage.skills.fabricjs",
        icon: "🎨",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "threejs",
        name: "Three.js 3D",
        description:
            "Create 3D scenes with animations, lighting, materials, and interactions.",
        descriptionKey: "skillsPage.skills.threejs",
        icon: "🧊",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "jspdf",
        name: "jsPDF",
        description:
            "Generate PDFs client-side with text, images, and custom fonts.",
        descriptionKey: "skillsPage.skills.jspdf",
        icon: "📄",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "html-to-image",
        name: "HTML to Image Export",
        description:
            "Convert React components into high-resolution exportable images.",
        descriptionKey: "skillsPage.skills.htmlToImage",
        icon: "🖼️",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "pptxgenjs",
        name: "PowerPoint Generation",
        description:
            "Generate PowerPoint presentations client-side with slides, text, and charts.",
        descriptionKey: "skillsPage.skills.pptxgenjs",
        icon: "📽️",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "pptx-design-extractor",
        name: "PowerPoint Design Extractor",
        description:
            "Extract colors, fonts, layouts, and design tokens from uploaded PowerPoint files.",
        descriptionKey: "skillsPage.skills.pptxDesignExtractor",
        icon: "🎨",
        serviceRequirement: "none",
        category: "documents",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "office-text-extractor",
        name: "Office Document Text Extractor",
        description:
            "Extract text from PowerPoint (.pptx) and Word (.docx) files — from uploads or URLs.",
        descriptionKey: "skillsPage.skills.officeTextExtractor",
        icon: "📝",
        serviceRequirement: "none",
        category: "documents",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "exceljs",
        name: "ExcelJS",
        description:
            "Create and read Excel spreadsheets with styling and formulas.",
        descriptionKey: "skillsPage.skills.exceljs",
        icon: "📊",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "papaparse",
        name: "CSV Parser",
        description:
            "Parse and generate CSV/TSV files with streaming, auto-detection, and dynamic typing.",
        descriptionKey: "skillsPage.skills.papaparse",
        icon: "📋",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "docx",
        name: "Word Document Generator",
        description:
            "Create Word documents from scratch with paragraphs, tables, images, and styles.",
        descriptionKey: "skillsPage.skills.docx",
        icon: "📄",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "docxtemplater",
        name: "Document Templates",
        description: "Generate Word/PowerPoint/Excel files from templates.",
        descriptionKey: "skillsPage.skills.docxtemplater",
        icon: "📝",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "pdfkit",
        name: "PDFKit (Backend)",
        description: "Generate PDFs programmatically in backend functions.",
        descriptionKey: "skillsPage.skills.pdfkit",
        icon: "📄",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    // Patterns (architecture guides for APP_V2)
    {
        id: "multi-tenant",
        name: "Multi-Tenant Architecture",
        description: "Add company_id to entities and isolate data per tenant.",
        descriptionKey: "skillsPage.skills.multiTenant",
        icon: "🏢",
        serviceRequirement: "none",
        category: "patterns",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "afip-sdk",
        name: "AFIP Electronic Billing",
        description:
            "Integrate with AFIP/ARCA for invoicing, taxpayer registry, and fiscal compliance.",
        descriptionKey: "skillsPage.skills.afipSdk",
        icon: "🧾",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    // Automation-compatible utility skills (server-side Deno)
    {
        id: "lodash",
        name: "Lodash",
        description:
            "Utility functions for sorting, grouping, filtering, and data transformation.",
        descriptionKey: "skillsPage.skills.lodash",
        icon: "🔧",
        serviceRequirement: "none",
        category: "components",
        isCodeGenSkill: true,
    },
    {
        id: "date-fns",
        name: "date-fns",
        description:
            "Modern date utility library for parsing, formatting, and manipulating dates.",
        descriptionKey: "skillsPage.skills.dateFns",
        icon: "📅",
        serviceRequirement: "none",
        category: "components",
        isCodeGenSkill: true,
    },
    {
        id: "moment-js",
        name: "Moment.js",
        description:
            "Date library for parsing, validation, formatting, and timezone handling.",
        descriptionKey: "skillsPage.skills.momentJs",
        icon: "🕐",
        serviceRequirement: "none",
        category: "components",
        isCodeGenSkill: true,
    },
    {
        id: "simple-statistics",
        name: "Simple Statistics",
        description:
            "Statistical functions: mean, median, regression, standard deviation, and more.",
        descriptionKey: "skillsPage.skills.simpleStatistics",
        icon: "📈",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "regression",
        name: "Regression Analysis",
        description:
            "Linear, polynomial, exponential, and logarithmic regression analysis.",
        descriptionKey: "skillsPage.skills.regression",
        icon: "📉",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "bwip-js",
        name: "Barcode Generator",
        description:
            "Generate barcodes and QR codes in various formats (Code128, EAN, UPC, QR).",
        descriptionKey: "skillsPage.skills.bwipJs",
        icon: "📊",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "html5-qrcode",
        name: "QR & Barcode Scanner",
        description:
            "Scan QR codes and barcodes using the device camera. Supports 17 formats including QR, Code 128, EAN-13, and UPC-A.",
        descriptionKey: "skillsPage.skills.html5Qrcode",
        icon: "📷",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "jszip",
        name: "JSZip",
        description:
            "Create, read, and modify ZIP files in the browser. Compress and extract files client-side.",
        descriptionKey: "skillsPage.skills.jszip",
        icon: "📦",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "browser-image-compression",
        name: "Image Compression",
        description:
            "Compress and resize images before upload using Web Workers for non-blocking UI.",
        descriptionKey: "skillsPage.skills.browserImageCompression",
        icon: "🖼️",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "dxf-viewer",
        name: "DXF Viewer",
        description:
            "Preview and render AutoCAD DXF files (floor plans, blueprints, engineering drawings) with layer toggling.",
        descriptionKey: "skillsPage.skills.dxfViewer",
        icon: "📐",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "microsoft-graph",
        name: "Microsoft Graph",
        description:
            "Access Microsoft 365 services: Outlook, OneDrive, Teams, SharePoint, and more.",
        descriptionKey: "skillsPage.skills.microsoftGraph",
        icon: "☁️",
        serviceRequirement: "none",
        category: "codeGeneration",
        isCodeGenSkill: true,
    },
    {
        id: "framer-motion",
        name: "Framer Motion",
        description:
            "Animation library for React with motion components, gestures, layout animations, and scroll effects.",
        descriptionKey: "skillsPage.skills.framerMotion",
        icon: "✨",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "react-hook-form",
        name: "React Hook Form + Zod",
        description:
            "Performant form handling with schema validation, field arrays, and error handling.",
        descriptionKey: "skillsPage.skills.reactHookForm",
        icon: "📋",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "hello-pangea-dnd",
        name: "Hello Pangea DnD",
        description:
            "Drag and drop for sortable lists, kanban boards, and reorderable items.",
        descriptionKey: "skillsPage.skills.helloPangeaDnd",
        icon: "🔀",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "cmdk",
        name: "cmdk",
        description:
            "Command palette component for searchable command menus and spotlight-style search.",
        descriptionKey: "skillsPage.skills.cmdk",
        icon: "⌨️",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "embla-carousel",
        name: "Embla Carousel",
        description:
            "Lightweight carousel/slider with autoplay, loop, drag, and responsive sizing.",
        descriptionKey: "skillsPage.skills.emblaCarousel",
        icon: "🎠",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "react-day-picker",
        name: "React Day Picker",
        description:
            "Date picker with single, multiple, and range selection modes.",
        descriptionKey: "skillsPage.skills.reactDayPicker",
        icon: "📅",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "react-dropzone",
        name: "React Dropzone",
        description:
            "Drag-and-drop file upload zone with type/size validation.",
        descriptionKey: "skillsPage.skills.reactDropzone",
        icon: "📂",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "react-quill",
        name: "React Quill",
        description:
            "Rich text WYSIWYG editor with toolbar customization and Delta format.",
        descriptionKey: "skillsPage.skills.reactQuill",
        icon: "✏️",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "react-markdown",
        name: "React Markdown",
        description:
            "Render markdown strings as React components with plugin support.",
        descriptionKey: "skillsPage.skills.reactMarkdown",
        icon: "📝",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "sonner",
        name: "Sonner",
        description:
            "Toast notifications with success/error/promise variants and action buttons.",
        descriptionKey: "skillsPage.skills.sonner",
        icon: "🔔",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "vaul",
        name: "Vaul",
        description:
            "Drawer/bottom sheet component with snap points and directional support.",
        descriptionKey: "skillsPage.skills.vaul",
        icon: "📱",
        serviceRequirement: "none",
        category: "components",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "tone",
        name: "Tone.js",
        description:
            "Audio synthesis and music library with synths, effects, and sequencing.",
        descriptionKey: "skillsPage.skills.tone",
        icon: "🎵",
        serviceRequirement: "none",
        category: "components",
    },
    {
        id: "create-agent-sdk",
        name: "Create Agent",
        description:
            "Call any LLM (OpenAI, Anthropic, Gemini) with tool loops, web search, and image generation from your app.",
        descriptionKey: "skillsPage.skills.createAgentSdk",
        icon: "🧠",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
    {
        id: "pdf-lib",
        name: "PDF Merge & Edit",
        description:
            "Merge, split, extract pages, and modify existing PDF documents client-side.",
        descriptionKey: "skillsPage.skills.pdfLib",
        icon: "📎",
        serviceRequirement: "none",
        category: "codeGeneration",
        isNew: true,
        isCodeGenSkill: true,
    },
];

export const INTEGRATION_SKILLS = [
    {
        integrationName: "skillsPage.integrations.apify.name",
        integrationDescription: "skillsPage.integrations.apify.description",
        integrationIcon: "🤖",
        skills: [
            {
                id: "TikTok Scraper",
                nameKey: "skillsPage.integrations.apify.tiktok",
                icon: "🎵",
            },
            {
                id: "Google Maps Scraper",
                nameKey: "skillsPage.integrations.apify.googleMaps",
                icon: "🗺️",
            },
            {
                id: "Instagram Scrapper",
                nameKey: "skillsPage.integrations.apify.instagram",
                icon: "📸",
            },
            {
                id: "Amazon Scraper",
                nameKey: "skillsPage.integrations.apify.amazon",
                icon: "📦",
            },
            {
                id: "Apify Other Actors",
                nameKey: "skillsPage.integrations.apify.otherActors",
                icon: "🔧",
            },
        ],
    },
    {
        integrationName: "skillsPage.integrations.googleDrive.name",
        integrationDescription:
            "skillsPage.integrations.googleDrive.description",
        integrationIcon: "📁",
        skills: [
            {
                id: "Google Docs Editor",
                nameKey: "skillsPage.integrations.googleDrive.docs",
                icon: "📝",
            },
            {
                id: "Google Sheets Automation",
                nameKey: "skillsPage.integrations.googleDrive.sheets",
                icon: "📊",
            },
            {
                id: "Google Slides Creator",
                nameKey: "skillsPage.integrations.googleDrive.slides",
                icon: "📽️",
            },
            {
                id: "Google Drive File Manager",
                nameKey: "skillsPage.integrations.googleDrive.fileManager",
                icon: "🗂️",
            },
        ],
    },
    {
        integrationName: "skillsPage.integrations.shopify.name",
        integrationDescription: "skillsPage.integrations.shopify.description",
        integrationIcon: "🛒",
        skills: [
            {
                id: "Shopify Read Orders",
                nameKey: "skillsPage.integrations.shopify.readOrders",
                icon: "📋",
            },
            {
                id: "Shopify Read Customers",
                nameKey: "skillsPage.integrations.shopify.readCustomers",
                icon: "👥",
            },
            {
                id: "Shopify Read Products",
                nameKey: "skillsPage.integrations.shopify.readProducts",
                icon: "📦",
            },
            {
                id: "Shopify Create Draft Order",
                nameKey: "skillsPage.integrations.shopify.createDraftOrder",
                icon: "📦",
            },
        ],
    },
];
